var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cw-latest-news"},[_vm._v("\n\t\t最新资讯\n  \t")])}
var staticRenderFns = []

export { render, staticRenderFns }